var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "studio-page-header",
          class: { "studio-page-header-long": !_vm.is_sidebar_minimized },
          attrs: { id: "header-position" }
        },
        [
          _c(
            "div",
            { staticClass: "d-flex" },
            [
              _c("img", {
                staticClass: "back-to-list-apps",
                attrs: { src: require("@/assets/icon/arrow-left.svg") },
                on: {
                  click: function($event) {
                    _vm.$router.push("/administrator/position")
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "auto__label-head" }, [
                _vm._v(" " + _vm._s(_vm.data_position.name) + " ")
              ]),
              _vm._v(" "),
              _vm.mode == "update"
                ? _c("b-col", [
                    _c("i", {
                      staticClass:
                        "fa fa-ellipsis-v fa-lg cursor-pointer pull-right m__t--10",
                      attrs: { id: "configPopover" }
                    })
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.mode == "update"
            ? _c("div", { staticClass: "sub-title" }, [
                _vm._v(_vm._s(_vm.assign_employee))
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "studio-page-content" },
        [
          _c(
            "b-row",
            { attrs: { "align-h": "start" } },
            [
              _c(
                "b-col",
                { attrs: { cols: "4" } },
                [
                  _c(
                    "b-form-group",
                    [
                      _c("label", [_vm._v("ID")]),
                      _vm._v(" "),
                      _c("j-input", {
                        attrs: {
                          "max-length": 255,
                          disabled: true,
                          placeholder: "ID"
                        },
                        model: {
                          value: _vm.data_position.id,
                          callback: function($$v) {
                            _vm.$set(_vm.data_position, "id", $$v)
                          },
                          expression: "data_position.id"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "4" } },
                [
                  _c(
                    "b-form-group",
                    {
                      class: { "error-input": _vm.$v.data_position.code.$error }
                    },
                    [
                      _c("label", [_vm._v("Code")]),
                      _vm._v(" "),
                      _c("j-input", {
                        attrs: { "max-length": 255, placeholder: "Code" },
                        model: {
                          value: _vm.data_position.code,
                          callback: function($$v) {
                            _vm.$set(_vm.data_position, "code", $$v)
                          },
                          expression: "data_position.code"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { attrs: { "align-h": "start" } },
            [
              _c(
                "b-col",
                { attrs: { cols: "4" } },
                [
                  _c(
                    "b-form-group",
                    {
                      class: { "error-input": _vm.$v.data_position.name.$error }
                    },
                    [
                      _c("label", [_vm._v("Position Name")]),
                      _vm._v(" "),
                      _c("j-input", {
                        attrs: {
                          "max-length": 255,
                          placeholder: "Position Name"
                        },
                        model: {
                          value: _vm.$v.data_position.name.$model,
                          callback: function($$v) {
                            _vm.$set(_vm.$v.data_position.name, "$model", $$v)
                          },
                          expression: "$v.data_position.name.$model"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "4" } },
                [
                  _c(
                    "b-form-group",
                    {
                      class: {
                        "error-input": _vm.$v.data_position.parent.$error
                      }
                    },
                    [
                      _c("label", [_vm._v("Parent Position")]),
                      _vm._v(" "),
                      _vm.defaultParentLoaded
                        ? _c("j-single-select", {
                            attrs: {
                              "is-async": true,
                              "load-options": _vm.loadOptionsParent,
                              "default-options": _vm.defaultParent,
                              "value-format": "object",
                              placeholder: "Select Parent",
                              label: "name",
                              "search-prompt-text":
                                "Type minimum 3 characters to search..."
                            },
                            model: {
                              value: _vm.$v.data_position.parent.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.data_position.parent,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.data_position.parent.$model"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { attrs: { "align-h": "start" } },
            [
              _c(
                "b-col",
                { attrs: { cols: "4" } },
                [
                  _c(
                    "b-form-group",
                    {
                      class: {
                        "error-input": _vm.$v.data_position.layer.$error
                      }
                    },
                    [
                      _c("label", [_vm._v("Layer")]),
                      _vm._v(" "),
                      _vm.defaultLayerLoaded
                        ? _c("j-single-select", {
                            attrs: {
                              "is-async": true,
                              "load-options": _vm.loadOptionsLayer,
                              "default-options": _vm.defaultLayer,
                              "value-format": "object",
                              placeholder: "Select Layer",
                              label: "name",
                              "search-prompt-text":
                                "Type minimum 3 characters to search..."
                            },
                            model: {
                              value: _vm.$v.data_position.layer.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.data_position.layer,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.data_position.layer.$model"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "4" } },
                [
                  _c(
                    "b-form-group",
                    {
                      class: {
                        "error-input": _vm.$v.data_position.divisions.$error
                      }
                    },
                    [
                      _c("label", [_vm._v("Unit")]),
                      _vm._v(" "),
                      _vm.defaultUnitLoaded
                        ? _c("j-single-select", {
                            attrs: {
                              "is-async": true,
                              "load-options": _vm.loadOptionsDivisions,
                              "default-options": _vm.defaultUnit,
                              "value-format": "object",
                              placeholder: "Select Unit",
                              label: "name",
                              "search-prompt-text":
                                "Type minimum 3 characters to search..."
                            },
                            model: {
                              value: _vm.$v.data_position.divisions.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.data_position.divisions,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.data_position.divisions.$model"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _vm.mode == "update"
                    ? _c(
                        "b-button",
                        {
                          staticClass: "btn m__r--5 blue",
                          on: { click: _vm.saveUpdatePosition }
                        },
                        [_vm._v("\n          Update\n        ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mode == "create"
                    ? _c(
                        "b-button",
                        {
                          staticClass: "btn m__r--5 blue",
                          on: { click: _vm.saveCreatePosition }
                        },
                        [_vm._v("\n          Create\n        ")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-popover",
        {
          ref: "configPopoverRef",
          attrs: {
            show: _vm.configPopoverShow,
            target: "configPopover",
            container: "header-position",
            placement: "bottom"
          },
          on: {
            "update:show": function($event) {
              _vm.configPopoverShow = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "position-config-opt",
              on: { click: _vm.onClickDelete }
            },
            [_vm._v("\n      Delete\n    ")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3037126a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3037126a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/position/jPositionForm.vue
// module id = null
// module chunks = 